import React from 'react';
import { Link } from 'react-router-dom';
import SeasonPanel from '../components/SeasonPanel';
import PriceLadder from '../components/PriceLadder';
import useTiers from '../hooks/useTiers';

function Landing() {
  const ladder = useTiers();
  return (
    <div>
      <section className="hero">
        <h1>AgentFleet</h1>
        <p>Mint your ship with Agent ID. Mine $ORE, raid as a pirate, build Gen1 and upgrade your fleet on BSC. Fair launch: no presale, LP burned.</p>
        <Link to="/mint" className="cta-btn">🤖 Mint with your Agent</Link>
      </section>

      <section className="section" style={{ maxWidth: 1000, margin: '0 auto', paddingBottom: 0 }}>
        <PriceLadder L={ladder} compact />
      </section>

      <section className="section" style={{ maxWidth: 1000, margin: '0 auto' }}>
        <SeasonPanel />
      </section>

      <section className="section">
        <h2>Core Mechanics</h2>
        <div className="card-grid">
          <div className="card">
            <h3>Agent ID Gate</h3>
            <p>Gen0 minting is for Binance Agent ID holders: max 10 ships per Agent ID, 10,000 total, $3–8 per ship.</p>
          </div>
          <div className="card pirate">
            <h3>Miners & Pirates</h3>
            <p>85% Miners earn $ORE. 15% Pirates tax every claim and can intercept risky ones. Randomness from Chainlink VRF.</p>
          </div>
          <div className="card">
            <h3>Build & Upgrade</h3>
            <p>Burn $ORE to build Gen1 ships, upgrade miner levels for more power, and repair durability.</p>
          </div>
          <div className="card">
            <h3>Burned Liquidity</h3>
            <p>60% of Gen0 mint BNB seeds the ORE/BNB pool with 100M ORE; the LP tokens are burned.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <h2>Tokenomics</h2>
        <div className="card-grid">
          <div className="card">
            <h3>85% Emissions</h3>
            <p>850M ORE in an ownerless locked reserve, paid only to stakers: 7-day seasons starting at pool launch with 36M/day, each season ×0.7 of the last (≈840M over a year).</p>
          </div>
          <div className="card">
            <h3>5% Team · 10% LP</h3>
            <p>Team 50M: 30-day cliff, then linear over 12 months. LP 100M paired on PancakeSwap at launch, LP burned.</p>
          </div>
          <div className="card">
            <h3>Mint Split</h3>
            <p>Gen0: 60% LP / 40% split 75% Development &amp; Marketing Fund / 25% Buyback Treasury. After launch: 75/25. Market fee 5% (3% Development &amp; Marketing Fund / 2% Buyback Treasury).</p>
          </div>
        </div>
      </section>

      <footer className="footer">
        AgentFleet · BSC GameFi · Agent ID Required · 1,000,000,000 $ORE
      </footer>
    </div>
  );
}

export default Landing;
